// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2LVKq","detailsBorder":"styles_detailsBorder__1sxyh"};